export const batchManagers = [
  {
    id: 63,
    first_name: 'Hanna',
    last_name: 'Runets',
    email: 'hanna@outtalent.com',
    employers: ['Outtalent']
  },
  {
    id: 2,
    first_name: 'Eldar',
    last_name: 'Azamatov',
    email: 'azamatov3333@gmail.com',
    employers: ['Outtalent']
  },
  {
    id: 46,
    first_name: 'Yakov',
    last_name: 'Shmidt',
    email: 'yakovshmidt93@gmail.com',
    employers: ['Uber', 'Apple']
  },
  {
    id: 334,
    first_name: 'Arman',
    last_name: 'Tsaturian',
    email: 'tsaturyanarmann@gmail.com',
    employers: ['Amazon']
  },
  {
    id: 428,
    first_name: 'Valera',
    last_name: 'Nemychnikova',
    email: 'sooobus@gmail.com',
    employers: ['Mistral', 'Google']
  },
  {
    id: 465,
    first_name: 'Gaziz',
    last_name: 'Tazhenov',
    email: 'gaziztazhenov@gmail.com',
    employers: ['Reddit', 'Doordash', 'Amazon']
  },
  {
    id: 278,
    first_name: 'Yoav',
    last_name: 'Nemirovsky',
    email: 'yoav.5.nem@gmail.com',
    employers: ['Uber']
  },
  {
    id: 605,
    first_name: 'Daniil',
    last_name: 'Korbut',
    email: 'korbut.daniel@gmail.com',
    employers: ['Amazon', 'Microsoft', 'Deliveroo']
  },
]

export const employers = [
  {
    name: 'Outtalent',
    logo: '/outtalent_logo.png',
  },
  {
    name: 'Uber',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_28/www.uber.com_logo.png',
  },
  {
    name: 'Apple',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_51/www.apple.com_logo.png',
  },
  {
    name: 'Google',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_226/www.google.com_logo.png',
  },
  {
    name: 'Amazon',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_11/amazon.com_logo.png',
  },
  {
    name: 'Reddit',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_20/www.reddit.com_logo.png',
  },
  {
    name: 'Doordash',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_196/www.doordash.com_logo.png',
  },
  {
    name: 'Mistral',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_1664/logo-1764658336277.ico',
  },
  {
    name: 'Microsoft',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_7/www.microsoft.com_logo.png',
  },
  {
    name: 'Deliveroo',
    logo: 'https://storage.googleapis.com/big-big-storage-of-images/media/uploads/employer_logos/employer_181/deliveroo.co.uk_logo.png',
  },
]

export const admins = [
  {
    id: 39,
    first_name: 'Tilek',
    last_name: 'Mamutov',
    email: 'tilek@outtalent.com',
  },
  {
    id: 2,
    first_name: 'Eldar',
    last_name: 'Azamatov',
    email: 'azamatov3333@gmail.com',
  },
  {
    id: 344,
    first_name: 'Aruuke',
    last_name: 'Murtaza',
    email: 'aruuke@outtalent.com',
  },
  {
    id: 374,
    first_name: 'Meder',
    last_name: 'Taab',
    email: 'medertaab@outtalent.com'
  },
]